import { render, staticRenderFns } from "./loginDia.vue?vue&type=template&id=a38acbb2&scoped=true&"
import script from "./loginDia.vue?vue&type=script&lang=js&"
export * from "./loginDia.vue?vue&type=script&lang=js&"
import style0 from "./loginDia.vue?vue&type=style&index=0&id=a38acbb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38acbb2",
  null
  
)

export default component.exports